export default __webpack_public_path__ + "static/media/luxurai-fictional-real-estate-postcard.55213759.jpg";